import { createAsyncThunk } from "@reduxjs/toolkit";

import magnifiAPI from "../../services/api/magnifi";

export const getLogsByType = createAsyncThunk(`logger/getLogsByType`, async (payload) => {
  try {
    const response = await magnifiAPI.getLogsByType(payload);

    return response.data;
  } catch (error) {
    console.error(error);
    throw error;
  }
});
